//medidad Banner 650x360px
export const ultimasNoticias = [
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Dibujo Pintura.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/36.-Taller de Dibujo y Pintura.pdf",
        "titulo" : "Taller de dibujo y pintura agentes de formación",
        "fecha" : "02 de septiembre al 27 de septiempre del 2026",
        "categoria" : "Talleres"
    },
    {
        "imagen" :"../assets/imgs/UltimasNoticias/CanalWA.jpeg",
        "url" : " https://script.google.com/macros/s/AKfycbwY9pre_VbhM686QHOhzktSeqGqAF8aOTuY2lEm2srdMyRsBGsEYLJBVz0XKTDsEyb6/exec?loc=web",
        "titulo" : "¡La agenda cultural, directo en tu WhatsApp! Consulta la cartelera semanal, exposiciones, conciertos, talleres y todos los eventos culturales y artísticos en un solo lugar.",
        "fecha" : "",
        "categoria" : "Canal de WhatsApp"
    },
    {
       "imagen" :"../assets/imgs/Convocatorias/2026/00217.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/35.-convocatoria Programa de  Nivelación, Evaluación y Certificación  de Competencias en el estándar EC00217.01.pdf",
        "titulo" : "Programa de  Nivelación, Evaluación y Certificación de Competencias en el estándar EC00217.01",
        "fecha" : "del 31 de agosto al 16 de septiempre del 2026",
        "categoria" : "Convocatoria"
    },
    {
       "imagen" :"../assets/imgs/Convocatorias/2026/0076.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/34.-CONVOCATORIA Programa de  Nivelación, Evaluación y Certificación  de Competencias en el estándar EC0076.pdf",
        "titulo" : "Programa de  Nivelación, Evaluación y Certificación de Competencias en el estándar EC0076 ",
        "fecha" : "del 31 de agosto al 14 de octubre del 2026",
        "categoria" : "Convocatoria"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Seminario de dirección escénica.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/32.-Seminario de dirección escénica.pdf",
        "titulo" : "SEMINARIO DE DIRECCIÓN ESCÉNICA: didácticas para la construcción de la puesta en escena",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
    {
        "imagen" :"../assets/imgs/Convocatorias/2026/Seminario en Muralismo Colectivo en Cerámica Escultórica.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/31.-Seminario en Muralismo Colectivo en Cerámica Escultórica.pdf",
        "titulo" : "Seminario en Muralismo Colectivo en Cerámica Escultórica",
        "fecha" : "Sujeto a disponibilidad de cupo",
        "categoria" : "Convocatoria"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/AIEC.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/créditos AIEC 2026.pdf",
        "titulo" : "Agentes Culturales de Cambio: Red de Formación Artística Especializada como Factor de Protección para las Infancias",
        "fecha" : "Sujeto a disponibilidad",
        "categoria" : "créditos"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Programa de Apoyos.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/13.-Convocatoria Fortalecimiento Actividades Artísticas y Culturales 2026.pdf",
        "titulo" : "Programa de Apoyos para el Fortalecimiento de Actividades Artísticas y Culturales del Ejercicio Fiscal 2026",
        "fecha" : "del 15 de junio al 30 de noviembre del 2026",
        "categoria" : "Convocatoria"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Convocatoria Ayudas sociales-2026.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/18.-Convocatoria Ayudas sociales-2026.pdf",
        "titulo" : "Programa de Ayudas Sociales para la Realización del Programa para la Administración de Bienes, Servicios y Financiamiento a la Cultura del Ejercicio Fiscal 2026",
        "fecha" : "del 10 de julio al 30 de noviembre del 2026",
        "categoria" : "Convocatoria"
    },
      
  
   ]